import React from 'react';
import SEOHead from '../components/SEOHead';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import Calculator from '../components/Calculator';
import ProcessSection from '../components/ProcessSection';
import DetailedProcessSection from '../components/DetailedProcessSection';
import AdvantagesSection from '../components/AdvantagesSection';
import StatsSection from '../components/StatsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import OfficesSection from '../components/OfficesSection';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="home-page">
      <SEOHead page="home" />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <Calculator />
      <ProcessSection />
      <DetailedProcessSection />
      <AdvantagesSection />
      <StatsSection />
      <TestimonialsSection />
      <OfficesSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
